// extracted by mini-css-extract-plugin
export var base = "_3o-0";
export var updateBanner = "_3o-1";